import { TagTypes } from '../../../Api/Types/tagTypes';
import type { BookingTag } from './bookingSettlementApi.contract';

export const CANCEL_BOOKING_CONFIRMATION_TEXT =
  'Anulować termin? Operacji nie można cofnąć. Anulowanie jest możliwe tylko wtedy, gdy wszystkie rezerwacje terminu są anulowane.';

export const buildCancelBookingRequest = (
  bookingId: number
): { url: string; method: 'POST' } => ({
  url: `/bookings/${bookingId}/cancel`,
  method: 'POST',
});

export const getCancelBookingInvalidatesTags = (bookingId: number): BookingTag[] => [
  { type: TagTypes.Booking, id: bookingId },
  { type: TagTypes.Booking, id: TagTypes.List },
];
